/**
 * components/CrudTable.jsx
 * Table shell — loading skeleton, empty state, or full table.
 * Receives row action handlers from FormsListApp and passes to TableBody.
 */

import { useCrudListState } from "../context/CrudContext";
import ResultsInfo from "./tableElements/ResultsInfo";
import TableHeader from "./tableElements/TableHeader";
import TableBody from "./tableElements/TableBody";
import TableFooter from "./tableElements/TableFooter";
import EmptyState from "./tableElements/EmptyState";

export default function CrudTable({
    onToggleStatus,
    onDuplicate,
    onTrash,
    onRestore,
    onPermanentDelete,
}) {
    const { loading, error, items } = useCrudListState();

    if (loading) {
        return (
            <div className="min-h-[200px] flex items-center justify-center">
                <div className="animate-pulse space-y-4 w-full p-6">
                    {[...Array(5)].map((_, i) => (
                        <div
                            key={i}
                            className="h-6 bg-gray-200 rounded w-full"
                        />
                    ))}
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="px-6 py-8 text-center">
                <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
                    {error}
                </p>
            </div>
        );
    }

    if (items.length === 0) {
        return <EmptyState />;
    }

    return (
        <>
            <ResultsInfo />
            <div className="overflow-x-auto">
                <table className="w-full">
                    <TableHeader />
                    <TableBody
                        onToggleStatus={onToggleStatus}
                        onDuplicate={onDuplicate}
                        onTrash={onTrash}
                        onRestore={onRestore}
                        onPermanentDelete={onPermanentDelete}
                    />
                </table>
            </div>
            <TableFooter />
        </>
    );
}
